// import LoginCardContainer from ;
import { RouteType } from '../../types/RouteType';

export const routesWithAuth: RouteType[] = [
  {
    path: '/login',
    layout: '/auth',
    name: 'Login Page',
    component: () => null,
    requiresAuth: false,
    requiresPermission: false,
    channels: [
      'channel',
      'user',
      'refresh-token',
      'email-login',
      'activate-user',
    ],
    enableAutoFind: false,
    onEnter: async ({ rootStore }) => {
      rootStore.userStore?.find();
    },

    // beforeEnter: async ({ rootStore, params, queryParams }) => {
    //   // console.log('Login Page beforeEnter', rootStore, params, queryParams);
    //   let result: boolean = true;
    //   // if (rootStore.appName === '@intrasync/revit-upload') {
    //   //   await rootStore.routerStore.setReturnRoute({
    //   //     route: 'LoginPage',
    //   //     params: toJS({ ...params }),
    //   //     queryParams: toJS({ ...queryParams })
    //   //   });
    //   // }
    //   // if (
    //   //   !['prod', 'production'].includes(rootStore.mode) &&
    //   //   !queryParams.enableForumLogin
    //   // ) {
    //   //   if (rootStore.routerStore.debugMode)
    //   //     console.warn(
    //   //       'goTo in routerStore',
    //   //       'LoginPage',
    //   //       {},
    //   //       { enableForumLogin: true }
    //   //     );
    //   //   rootStore.routerStore.goTo('LoginPage', {}, { enableForumLogin: true });
    //   //   return Promise.resolve(result);
    //   // }
    //   rootStore.userStore?.find();
    //   return result;
    // },
  },
  {
    path: '/external',
    layout: '/auth',
    name: 'External Auth',
    component: undefined,
    requiresAuth: false,
    requiresPermission: false,
    channels: [
      'channel',
      'user',
      'refresh-token',
      'email-login',
      'activate-user',
    ],
    // onEnter: async ({ rootStore, queryParams }) => {
    //   const {
    //     authStore: { authenticate },
    //   } = rootStore;
    //   if (queryParams && queryParams.accessToken) {
    //     const { accessToken } = queryParams;
    //     await authenticate({
    //       strategy: 'jwt',
    //       accessToken: accessToken,
    //     })
    //       .then(async () => {
    //         const {
    //           routerStore: { checkReturnRoute, goTo, defaultRoute },
    //         } = rootStore;
    //         const returnRoute = await checkReturnRoute();
    //         if (!returnRoute) {
    //           if (rootStore.routerStore.debugMode)
    //             console.warn('goTo in routerStore', defaultRoute);
    //           return goTo(defaultRoute);
    //         }
    //         if (rootStore.routerStore.debugMode)
    //           console.warn(
    //             'goTo in routerStore',
    //             returnRoute.route,
    //             returnRoute.params,
    //             returnRoute.queryParams
    //           );
    //         return goTo(
    //           returnRoute.route,
    //           returnRoute.params,
    //           returnRoute.queryParams
    //         );
    //       })
    //       .catch((err: any) => {
    //         console.warn(
    //           'Something went wrong trying to use external auth',
    //           err
    //         );
    //       });
    //   } else {
    //     console.warn('Looks like you ended up here on mistake');
    //     if (rootStore.routerStore.debugMode)
    //       console.warn('goTo in routerStore', 'LoginPage');
    //     rootStore.routerStore.goTo('LoginPage');
    //   }
    // },
  },
];
